import {SimplePresentation, SimplePresentationRunnerController} from "./SimplePresentationRunner";
import {Possessed} from "../../Possessed";
import {gsap} from "gsap";
import {PossessedSymbolStates} from "../../reels/PossessedSymbol";

export class IndiSymWinPresentation extends SimplePresentation {

    constructor() {
        super("IndiSymWinPresentation");
    }

    shouldRun() {
        return Possessed.model.wins.length > 0;
    }

    buildTimeline() {
    }

    start(controller: SimplePresentationRunnerController) {
        const tl = gsap.timeline();
        tl.add(this.playWinHighlight());
        tl.add(() => {
            controller.finish();
        });
        controller.setSkipCallback(() => {
            tl.timeScale(3);
        })
    }


    public playWinHighlight(): gsap.core.Timeline {
        const tl = gsap.timeline();

        const wins = Possessed.model.wins;
        let totalWays = 0;

        // Highlight winlines one by one
        wins.forEach((win, index) => {
            const winLineTL = gsap.timeline();
            let reePosForWinWays: number = 0;
            const winningSymbols = win.winningPositions.map(pos => {
                return Possessed.reelView.getSymbolAt(pos.reelID, pos.reelPosition);
            })
            const nonWinningSymbols = Possessed.reelView.getAllVisibleSymbols()
                .filter(sym => sym.getState() != PossessedSymbolStates.NO_WIN)
                .filter(sym => !winningSymbols.some(s => s == sym));

            // Remove darken on winning symbols
            winningSymbols.filter(s => s.getState() == PossessedSymbolStates.NO_WIN).forEach(sym => {
                winLineTL.add(sym.setNormal(), 0);
            })

            // Darken non winning
            nonWinningSymbols.forEach(sym => {
                winLineTL.add(sym.playNoWin(), 0);
            })

            // Play symbol wins
            const symbolsWinTL = gsap.timeline();
            winningSymbols.forEach(sym => {
                reePosForWinWays = sym.reelPosition
                symbolsWinTL.add(() => {
                    sym.moveToWinLayer();
                }, 0)
                symbolsWinTL.add(Possessed.reelView.winFireView.getSymIndiWinAnim(sym.reelID, sym.reelPosition), 0);
            });
            winLineTL.add(symbolsWinTL);

            // Move wins to normal layer
            winningSymbols.forEach((sym, index) => {
                winLineTL.add(sym.setNormal(), index == 0 ? ">" : "<");
                winLineTL.add(() => {
                    sym.moveToNormalLayer()
                }, "<");
            })
            winLineTL.add(Possessed.reelView.showIndividualWins(win,0.6),0);
            tl.add(winLineTL);
        });
        return tl;
    }

}